var _path, _path2, _path3, _circle, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chat Complete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "chatIllPrimarySB",
    d: "m53.5 75.6c-12.2 0-22.1-9.9-22.1-22.1 0-1.1 0.9-2 2-2s2 0.9 2 2c0 10 8.1 18.1 18.1 18.1s18.1-8.1 18.1-18.1c0-1.1 0.9-2 2-2s2 0.9 2 2c0 12.2-9.9 22.1-22.1 22.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "chatAccent1SB",
    d: "m50.6 6.9c-11 0.7-21.8 5.3-30 13.5-15 14.9-18.1 38-7.6 56.3l1 1.6-4.5 19.1 18.5-4.7 1.7 1c5.5 3.2 11.6 5.3 17.9 6.1-30.2-16.5-36-55.3-11.6-82.8 4.4-5 9.3-8.3 14.6-10.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "chatRedAlertSB",
    d: "m82.5 100c-0.8 0-1.5-0.5-1.5-1.1v-7.8c0-0.6 0.7-1.1 1.5-1.1s1.5 0.5 1.5 1.1v7.8c0 0.6-0.7 1.1-1.5 1.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "chatRedAlertSB",
    cx: 82.5,
    cy: 103.5,
    r: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "chatRedAlertSB",
    d: "m96.1 111.1h-26.7c-2.5 0-4.5-2-4.5-4.5 0-0.7 0.2-1.5 0.5-2.1l12.9-23.9c1.2-2.2 3.9-3 6.1-1.8 0.7 0.4 1.3 1 1.8 1.7l13.9 23.9c1.2 2.1 0.5 4.9-1.6 6.2-0.8 0.3-1.6 0.5-2.4 0.5zm-13.8-29.9c-0.5 0-1.1 0.3-1.3 0.8l-12.9 23.9c-0.1 0.2-0.2 0.5-0.2 0.7 0 0.8 0.7 1.5 1.5 1.5h26.7c0.3 0 0.5-0.1 0.8-0.2 0.7-0.4 1-1.3 0.5-2.1l-13.9-23.8c-0.1-0.2-0.3-0.4-0.6-0.6-0.2-0.1-0.4-0.2-0.6-0.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "chatIllPrimarySB",
    d: "m53.5 105.2c2.4 0 4.8-0.2 7.2-0.5l3-5.6c-3.3 0.7-6.7 1.1-10.2 1.1-8.4 0-16.6-2.3-23.8-6.5l-1.7-1-18.5 4.7 4.4-19.1-1-1.6c-10.4-18.3-7.3-41.4 7.7-56.3 14.9-14.9 38.1-17.9 56.3-7.3s27.1 32.2 21.7 52.5c-1.4 5.1-3.6 9.8-6.4 14l2.8 4.7c3.8-5.1 6.8-11 8.5-17.5 6.1-22.5-3.8-46.4-24-58.1-20.2-11.6-45.9-8.3-62.4 8.1s-20 42-8.4 62.3l-5.8 25.1 24.3-6.2c8 4.7 17.1 7.2 26.3 7.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatComplete);
export default __webpack_public_path__ + "static/media/chat-complete.cb75462f4103126967ae8ad19cd84e98.svg";
export { ForwardRef as ReactComponent };